import React, { forwardRef, InputHTMLAttributes } from "react";
import { cn } from "@/shared/utils/shadcn";

interface CheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  checked: boolean;
  label?: string | React.ReactNode;
  className?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { checked, label, className, onChange, ...rest } = props;

  return (
    <label
      className={cn("inline-flex items-center cursor-pointer gap-2", className)}
    >
      <input
        type="checkbox"
        className="sr-only"
        ref={ref}
        checked={checked}
        onChange={onChange}
        {...rest}
      />
      <div
        className={cn(
          "flex h-4 w-4 items-center justify-center rounded border border-grey-200 border-solid hover:border-primary",
          checked && "border-primary bg-primary"
        )}
      >
        {checked && (
          <svg
            className="h-2 w-2 text-white"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
              fill="currentColor"
            />
          </svg>
        )}
      </div>
      {!!label && <span className="select-none">{label}</span>}
    </label>
  );
});

Checkbox.displayName = "Checkbox";

export { Checkbox };
